import { usePermissions } from '@/lib/permissions-context';

export function usePermission(permission: string): boolean {
  const { permissions } = usePermissions();
  if (!permission) return true;
  return permissions.includes('*') || permissions.includes(permission);
}

export function useAnyPermission(...perms: string[]): boolean {
  const { permissions } = usePermissions();
  if (permissions.includes('*')) return true;
  return perms.some((p) => permissions.includes(p));
}
